import React from "react";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import { Modal } from "react-bootstrap";

import { getMyTrips, getTripHistories, getOwnerCars } from "../../model/car";
import { getMyCSTrips } from "../../model/carsubs";

import { LoadingPage, LoadingInline } from "../common/loading";
import { commonErr } from "../common/errors";

import { Empty } from "../common/messagebox";
import { getTripStatus, convertTimeToRecent, stypes } from "../common/common";

import { IcFilter3L } from "../common/svg";

import Session from "../common/session";
import Header from "../components/header";
import Footer from "../components/footer";
import AccountSidebar from "./components/accountsidebar";
import UserTripsFilter from "./usertripsfilter";
import CarItemMyTrips from "../common/caritemmytrips";

import empty from "../../static/images/empty/empty-trip.svg";

const viewMode = {
	TRIPS: 0,
	HISTORY: 1,
	CS: 2,
};

const defaultFilter = {
	sort: 3,
	userType: 0,
	status: 0,
	carId: "",
	fromTime: 0,
	toTime: 0,
	stype: 0, // 0:all 1:sd 2: wd
};

class TripItem extends React.Component {
	getTimeFromFilter = (trip, filter) => {
		if (!filter) {
			return convertTimeToRecent(trip.timeLastAction);
		}

		if (filter.sort == 2) {
			return convertTimeToRecent(trip.tripDateFrom);
		}

		if (filter.sort == 3) {
			return convertTimeToRecent(trip.timeLastAction);
		}

		return convertTimeToRecent(trip.timeBooked);
	};

	render() {
		const { car, trip, filter, mode } = this.props;
		const status = getTripStatus(trip.status, trip.needReview);
		const isSD = trip.serviceType === stypes.SD;

		return (
			<div className="my-trips__item">
				{/* {mode === viewMode.CS ? 
					<div className={`my-trips__item--header ${status.class}`}>
						<div className="title">
							<div className="wrap-svg">{status.ic}</div>
							<p>{status.name}</p>
						</div>
						<p className="time">{this.getTimeFromFilter(trip, filter)}</p>
					</div>
				
				:  */}
				<a href={`/trip/detail/${trip.id}`} target="_blank">
					<div className={`my-trips__item--header ${status.class}`}>
						<div className="title">
							<div className="wrap-svg">{status.ic}</div>
							<p>{status.name}</p>
						</div>
						<p className="time">{this.getTimeFromFilter(trip, filter)}</p>
					</div>
				</a>
				{/* } */}
				{/* <div className="space m"></div> */}
				<CarItemMyTrips car={car} trip={trip} isSD={isSD} mode={mode} />
			</div>
		);
	}
}

export class TripBar extends React.Component {
	constructor() {
		super();
		this.state = {
			hasFilter: false,
		};
	}
	componentWillReceiveProps(props) {
		const hasFilter = props.checkHasFilter();
		this.setState({
			hasFilter: hasFilter,
		});
	}
	render() {
		const { mode } = this.props;
		const { hasFilter } = this.state;

		return (
			<div className="mytrips-mode">
				<div className="tab-mode">
					<a className={`tab-mode__item ${mode === viewMode.TRIPS ? "active" : ""}`} onClick={this.props.viewMyTrips}>
						Chuyến hiện tại
					</a>
					<a
						className={`tab-mode__item ${mode === viewMode.HISTORY ? "active" : ""}`}
						onClick={this.props.viewTripHistories}>
						Lịch sử chuyến
					</a>
					{/* <a className={`tab-mode__item ${mode === viewMode.CS ? "active" : ""}`} onClick={() => this.props.viewCSTrips()}>
						Thuê xe dài hạn
					</a> */}
				</div>
				<a className={`btn btn--s ${hasFilter ? "has-red-dot" : ""}`} onClick={() => this.props.openFilter()}>
					<div className="wrap-svg">
						<IcFilter3L />
					</div>
					Bộ lọc
				</a>
			</div>
		);
	}
}

class MyTrips extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			mode: 0,
			trips: [],
			cars: [],
			carsForFilter: [],
			profiles: [],
			filter: [],
			isOpenFilterTrip: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		//

		this.setState({
			err: commonErr.LOADING,
		});

		getOwnerCars(0, 0, 0, 0, true).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.cars) {
				this.setState({
					carsForFilter: resp.data.data.cars,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
				});
			}
		});
		this.getTrips(0);
	}

	viewMyTrips = () => {
		this.setState(
			{
				mode: viewMode.TRIPS,
			},
			() => {
				this.resetFilter();
			}
		);
	};

	viewCSTrips = () => {
		this.setState(
			{
				mode: viewMode.CS,
			},
			() => {
				this.resetFilter();
			}
		);
	};

	viewTripsHistory = () => {
		this.setState(
			{
				mode: viewMode.HISTORY,
			},
			() => {
				this.resetFilter();
			}
		);
	};

	setFilter = (filter) => {
		this.setState({
			filter: filter,
		});
	};

	resetFilter = () => {
		this.setState(
			{
				filter: [],
			},
			() => {
				this.getTrips(this.state.filter);
			}
		);
	};

	getTrips = (filter) => {
		const { mode } = this.state;
		if (mode == viewMode.CS) {
			this.getCSTrips();
		} else if (mode == viewMode.HISTORY) {
			this.getTripHistories(filter);
		} else {
			this.getMyTrips(filter);
		}
	};

	getMyTrips = (filter) => {
		this.setState({
			err: commonErr.LOADING,
		});

		getMyTrips(filter, 0, 0, 0).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.trips) {
				this.setState({
					trips: resp.data.data.trips,
					profiles: resp.data.data.profiles,
					cars: resp.data.data.cars,
					more: resp.data.data.more,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
					trips: null,
					more: 0,
				});
			}
		});
	};

	getCSTrips = () => {
		this.setState({
			err: commonErr.LOADING,
		});

		getMyCSTrips(0).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					trips: resp.data.data.trips,
					profiles: resp.data.data.profiles,
					cars: resp.data.data.cars,
					more: resp.data.data.more,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
					trips: null,
					more: 0,
				});
			}
		});
	};

	getTripHistories = (filter) => {
		this.setState({
			err: commonErr.LOADING,
		});

		getTripHistories(filter, "", 0, 0).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.trips) {
				this.setState({
					trips: resp.data.data.trips,
					profiles: resp.data.data.profiles,
					cars: resp.data.data.cars,
					more: resp.data.data.more,
					lastId: resp.data.data.lastId,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
					trips: null,
					more: 0,
				});
			}
		});
	};

	getTripsMore = () => {
		const { filter, mode, trips, lastId } = this.state;
		const nextPos = mode == viewMode.HISTORY ? lastId : trips.length;
		if (mode == viewMode.CS) {
			getMyCSTrips(nextPos).then((resp) => {
				if (
					resp.data.error >= commonErr.SUCCESS &&
					resp.data.data.trips &&
					resp.data.data.cars &&
					resp.data.data.profiles
				) {
					this.setState({
						trips: this.state.trips.concat(resp.data.data.trips),
						profiles: this.state.profiles.concat(resp.data.data.profiles),
						cars: this.state.cars.concat(resp.data.data.cars),
						more: resp.data.data.more,
						err: resp.data.error,
					});
				} else {
					this.setState({
						err: resp.data.error,
						more: 0,
					});
				}
			});
		} else if (mode == viewMode.HISTORY) {
			getTripHistories(filter, nextPos, 0, 0).then((resp) => {
				if (
					resp.data.error >= commonErr.SUCCESS &&
					resp.data.data.trips &&
					resp.data.data.cars &&
					resp.data.data.profiles
				) {
					this.setState({
						trips: this.state.trips.concat(resp.data.data.trips),
						profiles: this.state.profiles.concat(resp.data.data.profiles),
						cars: this.state.cars.concat(resp.data.data.cars),
						more: resp.data.data.more,
						lastId: resp.data.data.lastId,
						err: resp.data.error,
					});
				} else {
					this.setState({
						err: resp.data.error,
						more: 0,
					});
				}
			});
		} else {
			getMyTrips(filter, 0, nextPos, 0).then((resp) => {
				if (
					resp.data.error >= commonErr.SUCCESS &&
					resp.data.data.trips &&
					resp.data.data.cars &&
					resp.data.data.profiles
				) {
					this.setState({
						trips: this.state.trips.concat(resp.data.data.trips),
						profiles: this.state.profiles.concat(resp.data.data.profiles),
						cars: this.state.cars.concat(resp.data.data.cars),
						more: resp.data.data.more,
						err: resp.data.error,
					});
				} else {
					this.setState({
						err: resp.data.error,
						more: 0,
					});
				}
			});
		}
	};

	toggleFilterTrip = () => {
		this.setState({
			isOpenFilterTrip: !this.state.isOpenFilterTrip,
		});
	};

	checkHasFilter = () => {
		const { filter } = this.state;
		const sortValue = filter && filter.sort > 0 ? filter.sort : defaultFilter.sort;
		const userTypeValue = filter && filter.userType > 0 ? filter.userType : defaultFilter.userType;
		const carId = filter && filter.carId ? filter.carId : "";
		const status = filter && filter.status > 0 ? filter.status : defaultFilter.status;
		const fromTime = filter && filter.fromTime > 0 ? filter.fromTime : defaultFilter.fromTime;
		const toTime = filter && filter.toTime > 0 ? filter.toTime : defaultFilter.toTime;
		const stype = filter && filter.stype > 0 ? filter.stype : defaultFilter.stype;

		return (
			sortValue != defaultFilter.sort ||
			userTypeValue != defaultFilter.userType ||
			carId != defaultFilter.carId ||
			status != defaultFilter.status ||
			fromTime != defaultFilter.fromTime ||
			toTime != defaultFilter.toTime ||
			stype != defaultFilter.stype
		);
	};

	render() {
		var content;
		let trips = [];
		let cars = [];
		let profiles = [this.state.profiles];
		const hasFilter = this.checkHasFilter();

		if (this.state.err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (this.state.err >= commonErr.SUCCESS && this.state.trips && this.state.cars && this.state.profiles) {
			let { trips, cars, profiles } = this.state;

			var i, j, k;
			const tripsInfo = [];

			for (i = 0; i < trips.length; ++i) {
				let trip = trips[i];
				for (j = 0; j < cars.length; ++j) {
					const car = cars[j];
					if (this.state.mode === viewMode.CS) {
						if (car.modelId === trip.modelId) {
							for (k = 0; k < profiles.length; ++k) {
								const profile = profiles[k];
								if (profile.uid === trip.ownerId || profile.uid === trip.travelerId) {
									tripsInfo.push({ trip, car, profile });
									break;
								}
							}
							break;
						}
					} else {
						if (car.id === trip.carId) {
							for (k = 0; k < profiles.length; ++k) {
								const profile = profiles[k];
								if (profile.uid === trip.ownerId) {
									tripsInfo.push({ trip, car, profile });
									break;
								}
							}
							break;
						}
					}
				}
			}

			content = (
				<InfiniteScroll
					pageStart={0}
					loadMore={this.getTripsMore}
					hasMore={this.state.more === 1}
					loader={
						<ul key={0}>
							<LoadingInline />
						</ul>
					}>
					{tripsInfo.map((tripInfo) => (
						<TripItem
							key={tripInfo.trip.id}
							trip={tripInfo.trip}
							car={tripInfo.car}
							owner={tripInfo.profile}
							filter={this.state.filter}
							mode={this.state.mode}
						/>
					))}
				</InfiniteScroll>
			);
		} else {
			if (hasFilter) {
				content = <Empty img={empty} msg={"Không tìm thấy chuyến nào."} />;
			} else {
				content = <Empty img={empty} msg={"Bạn chưa có chuyến"} />;
			}
		}

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<AccountSidebar />
								<div className="content-account">
									<div className="content-title">
										<h4>Chuyến của tôi</h4>
									</div>
									<TripBar
										openFilter={this.toggleFilterTrip}
										mode={this.state.mode}
										viewMode={viewMode}
										viewMyTrips={this.viewMyTrips}
										viewTripHistories={this.viewTripsHistory}
										checkHasFilter={this.checkHasFilter}
										viewCSTrips={this.viewCSTrips}
									/>

									<div className="list-car my-trips">{content}</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Footer />
				<Modal
					show={this.state.isOpenFilterTrip}
					onHide={this.toggleFilterTrip}
					dialogClassName="modal-m modal-dialog modal-trip-filter">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Bộ lọc</h5>
					</Modal.Header>
					<Modal.Body>
						<UserTripsFilter
							toggleFilterTrip={this.toggleFilterTrip}
							viewMode={viewMode}
							filter={this.state.filter}
							mode={this.state.mode}
							resetFilter={this.resetFilter}
							setFilter={this.setFilter}
							getTrips={this.getTrips}
							defaultFilter={defaultFilter}
							carsForFilter={this.state.carsForFilter}
							checkHasFilter={this.checkHasFilter}
						/>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}

export default MyTrips;
